import { http } from '../../config/axios'

const getClienteMotivosCancelamento = (): Promise<any> => {
  return http
    .get('api/client/motivos-cancelamento')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getClienteMotivosCancelamento', error)
      return []
    })
}

export default getClienteMotivosCancelamento;
